import axios from "axios"
import { baseURL, config, requestID } from "../../common/utils"

export const getVendors = async () => {

    const payload = {
        requestID: requestID()
    }

    try {
        const res = axios.post(`${baseURL}vendors/getAllVendors`, payload, config)
        console.log(res)
        return res
    } catch (error) {
        console.error(error)
    }
}